// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 문의사항 상세보기 - 전용 스타일 */
.qd-layout {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background: #f5f7fb;
}
.qd-layout main.qd-content {
  display: block;
  flex: 1 1;
  min-width: 0;
  height: auto;
  padding: 20px 28px 24px;
  box-sizing: border-box;
  color: #26354a;
  font-family: 'Malgun Gothic', Arial, sans-serif;
}
.qd-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}
.qd-layout .qd-heading h2 {
  position: relative;
  margin: 0 0 6px;
  padding: 0 0 15px;
  border-bottom: 1px solid #9f9f9f;
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
}
.qd-heading p {
  margin: 0;
  color: #8190a2;
  font-size: 13px;
}
.qd-panel {
  padding: 22px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 9px #1e375a10;
}
.qd-message {
  padding: 45px 22px;
  text-align: center;
  color: #8090a1;
}
.qd-error-actions {
  margin-top: 18px;
}
.qd-question-header {
  padding-bottom: 20px;
  border-bottom: 1px solid #e8edf3;
}
.qd-question-title {
  margin-bottom: 14px;
  font-size: 20px;
  font-weight: 700;
}
.qd-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  color: #697c91;
  font-size: 13px;
}
.qd-meta strong {
  margin-right: 10px;
  color: #34465b;
}
.qd-section {
  padding: 22px 0;
  border-bottom: 1px solid #e8edf3;
}
.qd-section:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.qd-section h3 {
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 700;
  color: #26354a;
}
.qd-question-body {
  min-height: 90px;
  padding: 18px;
  border: 1px solid #e4eaf2;
  border-radius: 6px;
  background: #f8fafc;
  font-size: 15px;
  line-height: 1.7;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.qd-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.qd-count {
  padding: 3px 9px;
  border-radius: 12px;
  background: #eaf3ff;
  color: #1671d8;
  font-size: 12px;
  font-weight: 700;
}
.qd-no-reply {
  padding: 25px 18px;
  border-radius: 6px;
  background: #f8fafc;
  color: #8090a1;
  text-align: center;
  font-size: 14px;
}
.qd-replies {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.qd-reply {
  padding: 18px;
  border: 1px solid #e4eaf2;
  border-radius: 6px;
  background: #f8fafc;
}
.qd-reply-header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  color: #34465b;
  font-size: 13px;
}
.qd-reply-header span {
  color: #8190a2;
}
.qd-reply-body {
  font-size: 15px;
  line-height: 1.7;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.qd-section textarea {
  width: 100%;
  min-height: 125px;
  padding: 13px;
  box-sizing: border-box;
  border: 1px solid #d9e0e9;
  border-radius: 6px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.6;
  resize: vertical;
}
.qd-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 14px;
}
.qd-back, .qd-error-actions button {
  padding: 9px 16px;
  border: 1px solid #d9e0e9;
  border-radius: 5px;
  background: #fff;
  color: #34465b;
  font-size: 13px;
  cursor: pointer;
}
.qd-submit {
  padding: 9px 20px;
  border: 1px solid #168ff0;
  border-radius: 5px;
  background: #168ff0;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.qd-submit:disabled {
  opacity: .5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/qna/AdminQnaDetail.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB","sourcesContent":["/* 문의사항 상세보기 - 전용 스타일 */\n.qd-layout {\n  display: flex;\n  width: 100%;\n  min-height: 100vh;\n  background: #f5f7fb;\n}\n.qd-layout main.qd-content {\n  display: block;\n  flex: 1;\n  min-width: 0;\n  height: auto;\n  padding: 20px 28px 24px;\n  box-sizing: border-box;\n  color: #26354a;\n  font-family: 'Malgun Gothic', Arial, sans-serif;\n}\n.qd-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 18px;\n}\n.qd-layout .qd-heading h2 {\n  position: relative;\n  margin: 0 0 6px;\n  padding: 0 0 15px;\n  border-bottom: 1px solid #9f9f9f;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 24px;\n}\n.qd-heading p {\n  margin: 0;\n  color: #8190a2;\n  font-size: 13px;\n}\n.qd-panel {\n  padding: 22px;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 2px 9px #1e375a10;\n}\n.qd-message {\n  padding: 45px 22px;\n  text-align: center;\n  color: #8090a1;\n}\n.qd-error-actions {\n  margin-top: 18px;\n}\n.qd-question-header {\n  padding-bottom: 20px;\n  border-bottom: 1px solid #e8edf3;\n}\n.qd-question-title {\n  margin-bottom: 14px;\n  font-size: 20px;\n  font-weight: 700;\n}\n.qd-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  color: #697c91;\n  font-size: 13px;\n}\n.qd-meta strong {\n  margin-right: 10px;\n  color: #34465b;\n}\n.qd-section {\n  padding: 22px 0;\n  border-bottom: 1px solid #e8edf3;\n}\n.qd-section:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n.qd-section h3 {\n  margin: 0 0 14px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #26354a;\n}\n.qd-question-body {\n  min-height: 90px;\n  padding: 18px;\n  border: 1px solid #e4eaf2;\n  border-radius: 6px;\n  background: #f8fafc;\n  font-size: 15px;\n  line-height: 1.7;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n.qd-section-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.qd-count {\n  padding: 3px 9px;\n  border-radius: 12px;\n  background: #eaf3ff;\n  color: #1671d8;\n  font-size: 12px;\n  font-weight: 700;\n}\n.qd-no-reply {\n  padding: 25px 18px;\n  border-radius: 6px;\n  background: #f8fafc;\n  color: #8090a1;\n  text-align: center;\n  font-size: 14px;\n}\n.qd-replies {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.qd-reply {\n  padding: 18px;\n  border: 1px solid #e4eaf2;\n  border-radius: 6px;\n  background: #f8fafc;\n}\n.qd-reply-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n  color: #34465b;\n  font-size: 13px;\n}\n.qd-reply-header span {\n  color: #8190a2;\n}\n.qd-reply-body {\n  font-size: 15px;\n  line-height: 1.7;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n.qd-section textarea {\n  width: 100%;\n  min-height: 125px;\n  padding: 13px;\n  box-sizing: border-box;\n  border: 1px solid #d9e0e9;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.6;\n  resize: vertical;\n}\n.qd-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 14px;\n}\n.qd-back, .qd-error-actions button {\n  padding: 9px 16px;\n  border: 1px solid #d9e0e9;\n  border-radius: 5px;\n  background: #fff;\n  color: #34465b;\n  font-size: 13px;\n  cursor: pointer;\n}\n.qd-submit {\n  padding: 9px 20px;\n  border: 1px solid #168ff0;\n  border-radius: 5px;\n  background: #168ff0;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.qd-submit:disabled {\n  opacity: .5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
